/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import OGBox from "assets/theme/components/OGBox";
import OGTypography from "assets/theme/components/OGTypography";
import typography from "assets/theme/theme-light/base/typography";
import brandLogo from "assets/images/others/oogoal.png";

function Footer({ company, links }) {
  const { href, name } = company;
  const { size } = typography;

  return (
    <OGBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <OGBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.xs}
        px={1.5}
      >
        <OGBox component="img" src={brandLogo} alt="ooGoal" width="1.5rem" />
        <Link href={href}>
          <OGTypography variant="button" fontWeight="medium">
            &nbsp;{name}&nbsp;&copy;&nbsp;
          </OGTypography>
        </Link>
        &nbsp;{new Date().getFullYear()}
      </OGBox>
      <OGBox
        component="ul"
        sx={({ breakpoints }) => ({
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          mt: 3,
          mb: 0,
          p: 0,

          [breakpoints.up("lg")]: {
            mt: 0,
          },
        })}
      >
        <NavLink key={links.name} to={links.href}>
          <OGTypography variant="caption" fontWeight="light">
            About ooGoal
          </OGTypography>
        </NavLink>
        <Link to={company.href}>
          <OGTypography variant="button" fontWeight="medium">
            <IconButton
              size="small"
              disableRipple
              color="inherit"
              aria-controls="reload"
              aria-haspopup="true"
              variant="contained"
              href={company.href}
            >
              <Icon>refresh</Icon>
            </IconButton>
          </OGTypography>
        </Link>
      </OGBox>
    </OGBox>
  );
}

Footer.defaultProps = {
  company: { href: "/oogoal", name: " ooGoal " },
  links: { href: "/about", name: " About " },
};

Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.objectOf(PropTypes.string),
};

export default Footer;
